import {Box, HStack, Input, Text, VStack} from "@chakra-ui/react";
import {Layout} from "react-admin";
import React from "react";
import {SectionHeader} from "../SectionHeader/SectionHeader";
import {FilterSidebar} from "../FilterSidebar/FilterSidebar";
import {useOrderStore} from "../../../store/use-order-store";

export const CustomNameField = ({
                                    nameOld,
                                    isSubmitting,
                                    errors,
                                    register,
                                }: {
    nameOld: string;
    isSubmitting: boolean;
    errors: any;
    register: any;
}) => {
    return (
        <Box mb={4}>
            <label>Nome (*)</label>
            <VStack alignItems="flex-start" w="100%">
                <Input
                    inputMode="text"
                    colorScheme="primary"
                    variant="filled"
                    _placeholder={{fontSize: 14}}
                    defaultValue={nameOld}
                    errorBorderColor="error.700"
                    disabled={isSubmitting}
                    isInvalid={!!errors.name}
                    focusBorderColor={!!errors.name ? "error.700" : "primary.400"}
                    {...register('name')}
                    placeholder="Es. Il mio prodotto"
                />
                {errors.name && (
                    <Text fontSize={14} alignSelf="start" color="error.700">
                        {errors.name.message}
                    </Text>
                )}
                <Text fontSize="14px" color="rgba(0,0,0,0.6)">
                    Il nome rappresentativo del tuo prodotto
                </Text>
            </VStack>
        </Box>
    );
};

export const CustomAppBar = (props: any) => (
    <Box as="header" p={4} color="white">
        <Text fontWeight={"bold"} fontSize={"20px"} color={"#54012F"}>ORDINI</Text>
    </Box>
);

const customStyles = {
    // "& .RaLayout-appFrame": {
    //     margin: 0,
    //     padding: 0,
    // },
};

export const CustomLayout = (props: any) => {
    const {searchText, setSearchText} = useOrderStore();

    return (
        <HStack w={"100%"} h={"100%"} overflow={"hidden"}>
            <VStack width={"70%"} maxWidth={"70%"} overflow={"hidden"} alignSelf={'stretch'} pt={"24px"}>
                <SectionHeader title={"Ordini"}/>
                <HStack w={'100%'} overflowY={'hidden'} overflowX={'auto'}>
                    <Layout appBar={() => null} sx={customStyles} appBarAlwaysOn={false}
                            sidebar={() => null} {...props} />
                </HStack>
            </VStack>
            <FilterSidebar
                searchProps={{
                    placeholder: "Inserisci cosa vuoi cercare",
                    searchInput: searchText,
                    onChangeText: setSearchText
                }}
                buttons={{
                    cancel: {
                        text: "Annulla",
                        onClick: () => {
                            setSearchText("")
                        }
                    }
                }}
                stackProps={{
                    width: "30%",
                    height: '100%',
                    alignSelf: 'stretch',
                    backgroundColor: "surfaceContainer.light",
                }}/>
        </HStack>
    )
};
